<template>
  <div class="page">
    <Tabs class="tabs" :tab-list="menuList" title="数据统计" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'statistics',
  data() {
    return {
      // 切换目录
      menuList: [
        {
          routerName: 'statistics',
          text: '交易数据统计',
        },
        {
          routerName: 'statistics/interface',
          text: '接口调用统计',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
</style>
